import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-mail-plus-icon lucide-mail-plus",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" }),
		/* @__PURE__ */ _jsx("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 16v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 19h6" })
	]
});
export default SvgMailPlus;
